import useContextStore from '@/stores/context'
import ModuleService from '@/services/moduleService'
import ProductService from '@/services/productService'
import OrderService from '@/services/orderService'
import ShopService from '@/services/shopService'
import CloudsyncService from '@/services/cloudsyncService'

import useTracking from '@/composables/useTracking'

export default function useService() {
  const context = useContextStore()
  const { getTrackingUserId } = useTracking()

  return {
    moduleService: new ModuleService(context),
    productService: new ProductService(context, getTrackingUserId() as string),
    orderService: new OrderService(context),
    shopService: new ShopService(context),
    cloudsyncService: new CloudsyncService(context),
  }
}
